import Vue from "vue"
import { mapState, mapGetters } from "vuex";
import { Component, Watch } from "vue-property-decorator"
import { IContractViewModel, ICustomerViewModel } from "../../../../../../Scripts/inpulse/I4UViewModels";

@Component({
    components: {
    }
})

export default class Membership extends Vue {

    get contract(): IContractViewModel { return this.$store.state.contract; }
    get contractMembershipTemp(): IContractViewModel { return this.$store.state.contractMembershipTemp; }

    membershiptypeid: number = 0;
    membershipchoice: number = 0;
    membership_choise: string = "En";

    constructor() {
        super();
    }

    mounted() {       
        this.init();
    }

    @Watch("membershipchoice")
    setMembership() {
        let value = this.membershipchoice == 0 ? 0 : this.membershiptypeid;
        this.$store.dispatch("changeValue", { key: "MembershipType", value: value });
    }

    private init() {
        if (this.contractMembershipTemp) {
            this.membershiptypeid = this.contractMembershipTemp.MembershipType;
        }
        if (this.contract.ContractMembership && this.contract.ContractMembership.MembershipType && this.contract.ContractMembership.MembershipType > 0) {
            this.membershipchoice = 1;
        }
        if (this.membershiptypeid == 4 || this.membershiptypeid == 6) {            
            this.membership_choise = "Ei";
        }        
    }
}